import React from 'react';
import { IconActionCross } from '@cko/icons';
import { TextHeadingOne } from '@cko/primitives';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-height: 100vh;
  background: var(--base-bg-primary);
`;
const Header = styled.header `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 65px;
  padding: var(--layout-sandgrain) var(--layout-shoe);
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
`;
const CloseButton = styled.button `
  display: flex;
  cursor: pointer;
  text-decoration: none;
  background: none;
  border: var(--border-b-sandgrain);
  margin-left: calc(-1 * var(--layout-seed));
  padding: var(--layout-seed);
  color: var(--base-icon-primary);
`;
const ActionsLeft = styled.div `
  left: var(--layout-shoe);
  position: absolute;
`;
const Title = styled.div `
  font: var(--heading-sm);
  color: var(--base-text-primary);
  text-align: center;
`;
const ActionsRight = styled.div `
  position: absolute;
  right: var(--layout-shoe);
`;
const MainContent = styled.div `
  flex: 1;
  overflow: auto;
`;
const Close = ({ onClose }) => {
    if (typeof onClose === 'string') {
        return (React.createElement(CloseButton, { as: Link, to: onClose, "aria-label": "Close" },
            React.createElement(IconActionCross, null)));
    }
    return (React.createElement(CloseButton, { onClick: onClose, "aria-label": "Close" },
        React.createElement(IconActionCross, null)));
};
/**
 * @deprecated - please use IA config to set up page layouts.
 * {@link https://checkout.atlassian.net/wiki/spaces/HUBV/pages/7053869259/Dashboard+Config+Structure}
 */
export const NewFullPageLayout = ({ title, onClose, onSubmit, actions, children, }) => (React.createElement(Container, { as: onSubmit ? 'form' : 'div', onSubmit: onSubmit },
    React.createElement(Header, null,
        React.createElement(ActionsLeft, null, !!onClose && React.createElement(Close, { onClose: onClose })),
        React.createElement(Title, { as: typeof title === 'string' ? TextHeadingOne : 'div' }, title),
        React.createElement(ActionsRight, null, actions)),
    React.createElement(MainContent, null, children)));
